export const backendUrl = process.env.NODE_ENV === 'development' ? 'http://localhost:3001' : 'https://ilgwt9jkf6.execute-api.eu-west-1.amazonaws.com/prod'
